var utils = require('../../utils')

export default {
  name: 'care-office-list',
  data: function () {
    return {
      shopList: [],
      showTabs: true,
      showTablists: true,
      showShops: true,
      showSelectList: false,
      nextUrl: null,
      careOfficeId: null,
      careOfficeName: '',
      duplicatedSearch: false,
      tradeHaltOnly: false,
      utils: utils,
      searchCallbackFlag: false, // 検索結果フラグ
      watchScroll: null,
      sortKey: '',
      sortStateOrder: '',
      sortState: {
        'careoffice_name_furigana': {'state': true,  'order': true},
        'address':                  {'state': false, 'order': false},
        'tel':                      {'state': false, 'order': false}
      },
      sortStateInit: {},
      maxShopCount: 8
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    if (utils.isPresent(this) && '$store' in this) {
      if (this.$store.getters.careOfficesSearchParams !== null) {
        this.$store.getters.careOfficesSearchParams['pageYOffset'] = window.pageYOffset // スクロール位置保存
        this.$store.getters.careOfficesSearchParams['scrollHeight'] = utils.getScrollHeight() // スクロール高さ保存
      }
      if (this.watchScroll !== null) {
        this.watchScroll.disconnect()
        this.watchScroll = null
      }
    }
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'}) // オートコンプリートイベント削除
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    next()
  },
  created () {
    var readMore = false

    // ソート初期化用保存
    for (var k in this.sortState) {
      this.sortStateInit[k] = {}
      this.sortStateInit[k].state = this.sortState[k].state
      this.sortStateInit[k].order = this.sortState[k].order
    }

    this.showSelectList = false
    if (this.shops) {
      this.shopSearch()
    }
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    if (this.$router.currentRoute.query.type === 'reports_history') {
      this.showTablists = false
      this.showShops = false
      var ssCareOfficeName = window.sessionStorage.getItem('rhco-careOfficeName')
      if (!!ssCareOfficeName) {
        this.careOfficeName = ssCareOfficeName
      }
    }

    if (this.$router.currentRoute.query.type === 'select_facility') {
      this.showTabs = false
      this.showSelectList = true
      var ssShopID = window.sessionStorage.getItem('sfco-shopID')
      var ssCareOfficeName = window.sessionStorage.getItem('sfco-careOfficeName')
      var ssTradeHaltOnly = window.sessionStorage.getItem('sfco-tradeHaltOnly')
      var ssSortKey = window.sessionStorage.getItem("sfco-sortKey")
      var ssSortStateOrder = window.sessionStorage.getItem("sfco-sortStateOrder")
      if (!!ssShopID) {
        if (ssShopID === 'null') {
          this.shopId = null
        } else {
          this.shopId = ssShopID
        }
      }
      if (!!ssCareOfficeName) {
        this.careOfficeName = ssCareOfficeName
      }
      if (!!ssTradeHaltOnly) {
        this.tradeHaltOnly = Boolean(ssTradeHaltOnly)
      }
      if (!!ssSortKey) {
        var key = ssSortKey
        this.sortKey = key
        if (ssSortStateOrder != null) {
          if (ssSortStateOrder === "true") {
            this.sortStateOrder = true
          } else {
            this.sortStateOrder = false
          }
        } else {
          this.sortStateOrder = !this.sortState[key].order
        }
        for (var k in this.sortState) {
          this.sortState[k].state = false
          if (k !== key) {
            this.sortState[k].order = false
          }
        }
        this.sortState[key].state = true
        this.sortState[key].order = this.sortStateOrder
      }
    }

    this.search(readMore)

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#careoffice_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getCareOffices,
      setSearchData:      this.setSearchCareOffice,
      clear:              this.clearCareOfficesAutocomplete,
    })

    // 最下部スクロールイベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  mounted () {
    if (this.$router.currentRoute.query.type === 'select_facility') {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    careOffices () {
      return this.$store.getters.careOffices
    },
    careOfficesAutocomplete () {
      return this.$store.getters.careOfficesAutocomplete
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    nextPage () {
      return this.$store.getters.careOfficesNextPage
    },
    totalCount () {
      return this.$store.getters.careOfficesTotalCount
    },
    currentPage () {
      return this.$store.getters.careOfficesCurrentPage
    },
    shops () {
      return this.$store.getters.shops
    },
    /** 通知 */
    notify() {
      return this.$store.getters.careOfficeNotify
    },
    overShopCount () {
      if (this.shopList.length > this.maxShopCount) {
        return true
      }
      return false
    }
  },
  methods: {
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type}})
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type}})
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type}})
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    goNext: function (id) {
      if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/reports/history/care_office/' + id , query: { type: this.$router.currentRoute.query.type}})
      } else {
        this.$router.push({ name: 'CareOfficeDetail', params: { careOfficeId: id }, query: { type: this.$router.currentRoute.query.type}})
      }
    },
    goPrev: function () {
      if (this.$router.currentRoute.query.type === 'create_report') {
        this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
      } else if (this.$router.currentRoute.query.type === 'reports_history') {
        this.$router.push({ path: '/', query: { type: this.$router.currentRoute.query.type}})
      }
      this.$router.push({ path: '/' })
    },
    goNewEdit: function () {
      this.$router.push({ path: '/care_offices/edit', query:{type: this.$router.currentRoute.query.type} })
    },
    setSearchCareOffice: function (careOfficeId, careOfficeName) {
      this.careOfficeName = careOfficeName
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 100)
    },
    clearCareOffices: function() {
      this.$store.dispatch('CARE_OFFICE_CLEAR', 0)
    },
    clearCareOfficesAutocomplete: function () {
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 500)
    },
    getCareOffices: function() {
      this.careOfficeId = null
      this.search(false, 'autocomplete')
    },
    search: function (readMore, mode) {
      var url = null
      var clear = true
      var autocomplete = false
      var loadparams = true
      var send_fails = 0
      var self = this

      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)

      if (readMore === 'sort') {
        // ソート読み込み
        clear       = false
        loadparams  = 'block'
      } else if (readMore === 'keepload') {
        // 再読込
        clear = false
        loadparams = 'block'
        this.searchCallbackFlag = true

        // スクロール位置
        var pageYOffset = this.$store.getters.careOfficesSearchParams['pageYOffset']
        var scrollHeight = this.$store.getters.careOfficesSearchParams['scrollHeight']
        this.$store.getters.careOfficesSearchParams['pageYOffset'] = null
        this.$store.getters.careOfficesSearchParams['scrollHeight'] = null
        this.watchScroll = utils.setScrollHeight(scrollHeight, pageYOffset)
      } else if (readMore) {
        // 次ページ
        url = this.$store.getters.careOfficesNextPageLink
        clear = false
        loadparams = 'block'
      } else {
        if (mode !== 'autocomplete') {
          this.searchCallbackFlag = false
        }
      }

      if (mode === 'autocomplete') {
        autocomplete = true
        clear = false
        loadparams = false
      } else {
        if (this.$router.currentRoute.query.type === 'reports_history') {
          send_fails = 1
        }
      }

      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }

      var data = {
        'shop_id':          this.shopId,
        'careoffice_name':  this.careOfficeName,
        'send_fails':       send_fails,
        'duplicate_flag':   this.duplicatedSearch,
        'trade_halt_only':  this.tradeHaltOnly,
        'order':            this.orderByString(),
        'type':             this.$router.currentRoute.query.type
      }
      if (readMore === 'sort' || readMore === 'keepload') {
        // ソート、再読込 現在のページを指定
        data['current_page'] = this.currentPage
      } else {
        data['current_page'] = null
      }

      if (this.$router.currentRoute.query.type === 'reports_history') {
        if (!!this.careOfficeName) {
          window.sessionStorage.setItem('rhco-careOfficeName', this.careOfficeName)
        } else {
          window.sessionStorage.removeItem('rhco-careOfficeName')
        }
      }

      if (this.$router.currentRoute.query.type === 'select_facility') {
        window.sessionStorage.setItem('sfco-shopID', this.shopId)
        if (!!this.careOfficeName) {
          window.sessionStorage.setItem('sfco-careOfficeName', this.careOfficeName)
        } else {
          window.sessionStorage.removeItem('sfco-careOfficeName')
        }
        if (!!this.tradeHaltOnly) {
          window.sessionStorage.setItem('sfco-tradeHaltOnly', this.tradeHaltOnly)
        } else {
          window.sessionStorage.removeItem('sfco-tradeHaltOnly')
        }
        if (!!this.sortKey) {
          window.sessionStorage.setItem("sfco-sortKey", this.sortKey)
        } else {
          window.sessionStorage.removeItem("sfco-sortKey")
        }
        if (this.sortStateOrder !== "") {
          window.sessionStorage.setItem("sfco-sortStateOrder", this.sortStateOrder)
        } else {
          window.sessionStorage.removeItem("sfco-sortStateOrder")
        }
      }

      this.$store.dispatch('CARE_OFFICE_SEARCH', {
        url:          url,
        clear:        clear,
        data:         data,
        autocomplete: autocomplete,
        loadparams:   loadparams,
        callback:     callback,
      })
    },
    duplicatedTel: function () {
      this.duplicatedSearch = !this.duplicatedSearch
      this.search(false)
    },
    getDuplicatedTelClass: function (flag) {
      return flag ? 'btn-success' : 'btn-default'
    },
    shopSearch: function () {
      // this.$store.dispatch('SHOP_SEARCH')
      this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    },
    sortBy: function(key) {
      this.sortKey = key
      this.sortStateOrder = !this.sortState[key].order
      for (var k in this.sortState) {
        this.sortState[k].state = false
        if (k !== key) {
          this.sortState[k].order = false
        }
      }
      this.sortState[key].state = true
      this.sortState[key].order = !this.sortState[key].order

      // 検索
      this.search('sort')
    },
    getArrow: function(key) {
      var state = this.sortState[key].state ? ' color-light-blue' : ''
      var arrow = this.sortState[key].order ? 'fa-arrow-up' : 'fa-arrow-down'
      return arrow + state
    },
    /** ソート文字列取得 */
    orderByString: function() {
      var result = []
      for (var key in this.sortState) {
        if (this.sortState[key].state) {
          var asc_desc = 'asc'
          if (!this.sortState[key].order) {
            asc_desc = 'desc'
          }
          if (key === 'address') {
            result.push('post_no ' + asc_desc)
            result.push('address1 ' + asc_desc)
            result.push('address2 ' + asc_desc)
          } else {
            result.push(key + ' ' + asc_desc)
          }
        }
      }
      if (result.length <= 0) {
        // 存在しない場合
        result.push('careoffice_name_furigana asc')
      }
      return result.join(' , ')
    },
    // 店舗別担当施設表示  
    goSurroundingSearchByShops: function() {
      if (this.overShopCount) {
        return
      }
      this.shopList.sort(function (a, b) {
        return a - b
      })
      var data = {
        'shop_list': this.shopList
      }
      this.$store.dispatch('CARE_OFFICE_SHOP_LIST_SAVE', {data: this.shopList})
      this.$store.dispatch('CARE_OFFICE_SEARCH_BY_SHOP', {data: data, callback: () => {
        this.$router.push({ name: 'careOfficeSurrounding', query: { type: this.$router.currentRoute.query.type}})
      }})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/care-office-list.js